import { motion } from 'motion/react';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';

function ScrollArrow({ direction, onClick, position, visible = true }) {
  const isDown = direction === 'down';
  const Icon = isDown ? KeyboardDoubleArrowDownIcon : KeyboardDoubleArrowUpIcon;
  const bounceY = isDown ? [0, 8, 0] : [0, -8, 0];

  // Pad by the matching safe-area inset so the down arrow clears the phone's
  // bottom gesture bar and stays balanced with the top arrow.
  const safeInset = isDown ? 'env(safe-area-inset-bottom, 0px)' : 'env(safe-area-inset-top, 0px)';
  const edgeOffset = `calc(clamp(2.25rem, 4vw, 2.5rem) + ${safeInset})`;

  return (
    <motion.div
      animate={{ opacity: visible ? 1 : 0 }}
      transition={{ duration: 0.4 }}
      style={{ position: 'absolute', [position]: edgeOffset, left: 0, right: 0, display: 'flex', justifyContent: 'center' }}
    >
      <motion.div
        onClick={onClick}
        animate={{ y: bounceY }}
        transition={{ repeat: Infinity, duration: 1.5, ease: 'easeInOut' }}
        style={{ cursor: 'pointer' }}
      >
        <Icon sx={{ fontSize: 40, color: 'white' }} />
      </motion.div>
    </motion.div>
  );
}

export default ScrollArrow;
